import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    emailSent: false,
    email: "",
    error: false,
    errorPhrase: ""
}

const forgotPasswordSlice = createSlice({
    name: "forgotPassword",
    initialState,
    reducers: {
        fpEmailConfirmed: (state,action) => {
            state.emailSent = true
            state.email = action.payload.email
        },
        fpEmailError: (state,action) => {
            state.error = true
            state.errorPhrase = action.payload.errorPhrase
        },
        reset: state => initialState,
    },
})

export const { fpEmailConfirmed, fpEmailError, reset } = forgotPasswordSlice.actions
export default forgotPasswordSlice.reducer